// extracted by mini-css-extract-plugin
module.exports = {"quickChat":"quickChat_quickChat__1-5zW","smiley":"quickChat_smiley__3bP_u","Text":"quickChat_Text__S3asC"};